import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { FormService } from 'src/app/services/form';
import { Router } from '@angular/router';
import { PEAssignment } from 'src/app/models/pe-assignment';
import { DataService } from 'src/app/services/data.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { of } from 'rxjs';
import { PartSystemDTO } from 'src/app/models/external/partsystem-dto';
import { SourceType } from 'src/app/models/sourcetype';
import { QueryAssignmentsForPEDTO } from 'src/app/models/internal/query-assignments-for-pe-dto';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { AppSettings } from 'src/app/app.settings';
import { Constants } from 'src/app/core/constants';
import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { NGXLogger } from 'ngx-logger';
import UIHelper from '../../core/utility/ui-helper';

@Component({
    selector: 'app-pe-assignment',
    templateUrl: './pe-assignment.component.html',
    styleUrls: ['./pe-assignment.component.scss'],
})
export class PeAssignmentComponent extends BaseGridPage implements OnInit, AfterViewInit {
    appSettings: AppSettings;
    pe_assignmentSearchForm: FormGroup;
    peList: number[];
    peAssignmentsList: any[];
    sourceTypeList: SourceType[];
    partSystemList: PartSystemDTO[];
    availablePartSystemList: PartSystemDTO[];
    sourceTypeId: number;
    partSystemId: number;
    searchSupplierURL: string;
    supplierAssginmentMessage: string = '';
    @ViewChild('PEAutoComplete') PEAutoComplete: TeslaAutocompleteComponent;
    @ViewChild('SupplierAutoComplete') SupplierAutoComplete: TeslaAutocompleteComponent;
    autoCompletePEURL: string;
    public formErrors = {
        PEId: '',
        SourceTypeId: '',
        PartCategoryId: '',
        SupplierCode: ''
    };

    searchClicked = false;

    constructor(
        private dataService: DataService,
        private fb: FormBuilder,
        private toastService: ToastService,
        public FormService: FormService,
        localstorageService: LocalstorageService,
        private spinnerService: SpinnerService,
        logger: NGXLogger,
        appSettings: AppSettings,
            private router: Router
    ) {
        super(localstorageService, logger, appSettings);
        this.pe_assignmentSearchForm = this.fb.group({
            PEId: [null],
            SourceTypeId: [null],
            PartCategoryId: [null],
            SupplierCode: [null]
        });
        this.appSettings = appSettings;
        this.autoCompletePEURL = this.appSettings.Packaging2APIUrl + '/peassignment/pe/all';
        this.searchSupplierURL = this.appSettings.Packaging2APIUrl + '/externaldata/supplier/all';
    }

    ngOnInit() {
        this.initFilterValues();
        this.pe_assignmentSearchForm.controls['PEId'].patchValue(0);
        this.searchClicked = true;
        this.getAllCurrentAssignments();
    }
    initFilterValues(): void {
        this.filter = new SearchFilter();
    }

    fillGrid(): void {
        this.filter.Skip = this.skip;
        this.filter.Take = this.pageSize;
        this.UpdateFilter();
        this.getAllCurrentAssignments();
      //  this.reloadAvailablePartSystems();
        // this.allItemsCheckBoxSelected = false;
        // let queryPendingProposalDTO: QueryPendingProposalDTO = {
        //     SearchFilter: this.filter
        // }
        // this.getPendingProposals(queryPendingProposalDTO);
    }

    getAllPEs() {        
        this.dataService
            .getPEs()
            .subscribe((response: any) => {
                // this.partInfo = response
                if (response != null) {
                    this.peList = response.Data;
                }
            });
    }

    UpdateFilter() {        
        if (this.PEAutoComplete.list.length === 0) {
            this.pe_assignmentSearchForm.controls['PEId'].patchValue(-1);
        }
        if (this.getPEId() == null) {
            this.pe_assignmentSearchForm.controls['PEId'].patchValue(-1);
        }
        this.pe_assignmentSearchForm.clearValidators();
        this.filter.SearchFilterConditions = [];
        this.filter = this.setFilterCondition(this.filter, this.pe_assignmentSearchForm, 'SourceTypeId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.pe_assignmentSearchForm, 'PartCategoryId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.pe_assignmentSearchForm, 'SupplierCode', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
    }

    onEmptyPE(eventObj: any): void {
        this.PEAutoComplete.list = [];
    }

    getAllCurrentAssignments() {
        const queryAssignmentsForPEDTO: QueryAssignmentsForPEDTO = new QueryAssignmentsForPEDTO();
        queryAssignmentsForPEDTO.SearchFilter = this.filter;
        queryAssignmentsForPEDTO.PEId = this.getPEId();        
        this.dataService
            .getPECurrentAssignments(queryAssignmentsForPEDTO)
            .subscribe((response: any) => {
                // this.partInfo = response
                if (response != null) {
                    this.peAssignmentsList = response.Data;
                    this.gridView = of({
                        data: response.Data,
                        total: response.Total ? response.Total : 0,
                    });
                    this.getPartSystems();
                    this.getSourceTypes();
                }
            });
    }

    deletePEAssignment(peAssignmentId: number) {
        this.dataService
            .deletePEAssignment(peAssignmentId)
            .subscribe((response: any) => {
                if (response != null && response.Success) {
                    this.toastService.success('PE assignment deleted');
                }
                this.fillGrid();
            });
    }

    createPEAssignment() {
        this.router.navigate(['pe-add-assignment']);
    }

    /*
    At least one filter should be applied for search assignments.
    */
    checkSearchFormFilter(): boolean {
        return this.pe_assignmentSearchForm.controls['PEId'].value ||
                this.pe_assignmentSearchForm.controls['SourceTypeId'].value ||
                this.pe_assignmentSearchForm.controls['PartCategoryId'].value ||
                this.pe_assignmentSearchForm.controls['SupplierCode'].value;
    }

    searchPEAssignment() {
        this.ValidateSearchForm();
        if (this.pe_assignmentSearchForm.valid) {
            // get current assignments
            this.searchClicked = true;
            // this.UpdateFilter();
            this.search();
        }
        // If the SourceTypeId is not null in pe_addAssignmentForm, update the part categories by the SourceTypeId.
       // this.reloadAvailablePartSystems();      
    }

    clearFilter() {
        window.location.reload();
        // this.pe_assignmentSearchForm.reset();
        // this.pe_assignmentSearchForm.controls['PEId'].patchValue(0);

        // // this.getAllCurrentAssignments();
        // this.search();
      //  this.reloadAvailablePartSystems();
    }

    getSourceTypes() {        
        this.dataService.getParentSourceTypes().subscribe((response: any) => {
            if (response != null && response.Success) {
                this.sourceTypeList = response.Data;
                // this.sourceTypeList = this.excludeAlreadyAssignedSourceTypes(this.sourceTypeList);
            }
        });
    }
    getPartSystems() {        
        this.dataService.getPartSystems().subscribe((response: any) => {
                if (response != null && response.Success) {
                    this.partSystemList = response.Data;
                    // this.partSystemList = this.excludeAlreadyAssignedPartSystems(this.partSystemList);
                }
            });
    }

    excludeAlreadyAssignedPartSystems(masterList: PartSystemDTO[]) {
        this.peAssignmentsList.forEach(element => {
            const assignedPartSystemId = element.PartSystemId;
            masterList = masterList.filter(function (obj) {
                return obj.Id != assignedPartSystemId;
            });
        });
        return masterList;
    }

    excludeAlreadyAssignedSourceTypes(masterList: SourceType[]) {
        this.peAssignmentsList.forEach(element => {
            const assignedSourceTypeId = element.SourceTypeId;
            masterList = masterList.filter(function (obj) {
                return obj.Id != assignedSourceTypeId;
            });
        });
        return masterList;
    }

    sourceTypeChanged(event) {
        this.dataService.getPartSystemsAvailableBySourceTypeId(event).subscribe((response: any) => {
            if (response != null && response.Success) {
                this.availablePartSystemList = response.Data;
                // this.partSystemList = this.excludeAlreadyAssignedPartSystems(this.partSystemList);
            }
        });
    }

    partSystemChanged(event) {

    }

    ValidateSearchForm() {
        this.formErrors = this.FormService.validateForm(
            <FormGroup>this.pe_assignmentSearchForm,
            this.formErrors
        );
    }

    getPEId() {
        return this.pe_assignmentSearchForm.controls['PEId'].value;
    }

    getSupplierCode() {
        return this.pe_assignmentSearchForm.controls['SupplierCode'].value;
    }

    peChanged(event) {
    }

    onEmptySupplierCode(eventObj: any): void {
      //  this.pe_addAssignmentForm.controls['SupplierCode'].patchValue(null);
        this.SupplierAutoComplete.list = [];
        if (this.filter != null && this.filter.SearchFilterConditions != null && this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode') >= 0) {
            this.filter.SearchFilterConditions.splice(this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode'), 1);
        }
    }

    refreshToolTipText(code: string) {
        this.supplierAssginmentMessage = Constants[code];
    }
}

